<template>
  <LoadingSpinner v-if="loading" />
  <EnvelopeSigned v-else-if="enabled" />
  <EnvelopeComplete v-else />
</template>

<script setup>
// @ts-check
import { useFlagEnabled } from '@/composables/useFlagEnabled'

import LoadingSpinner from '@/components/LoadingSpinner.vue'
import EnvelopeComplete from '@/views/EnvelopeComplete.vue'
import EnvelopeSigned from '@/views/EnvelopeSigned.vue'

const [loading, enabled] = useFlagEnabled('moooore-branding')
</script>
